import { SUB_VERSION_MIGRATION, SUB_EX_AGE } from '@/store/const/expertise'
import { copyObject } from '@/lib/objects'
import {
  EX_AGENCIES_DEFAULT,
  DEFAULT_AGENCIES_LIST,
  DEFAULT_INDICATION,
  DEFAULT_AGENCY_CONCLUSION,
  normalizeAgenciesExpertise,
  buildAgenciesTableRows,
  indicationTabLabel,
  indicationHasContent,
  isLegacyAgenciesFormat,
} from './agencyUtils'

export const EX_AGENCIES_TEMPLATE_VERSION = 4

export const EX_AGENCIES_NICE = 0
export const EX_AGENCIES_IQWIG = 1
export const EX_AGENCIES_CADTH = 2

export {
  EX_AGENCIES_DEFAULT,
  DEFAULT_AGENCIES_LIST,
  DEFAULT_INDICATION,
  DEFAULT_AGENCY_CONCLUSION,
  normalizeAgenciesExpertise,
  buildAgenciesTableRows,
  indicationTabLabel,
  indicationHasContent,
  isLegacyAgenciesFormat,
}

// Установили текущую версию данных
SUB_VERSION_MIGRATION[SUB_EX_AGE].v = EX_AGENCIES_TEMPLATE_VERSION

SUB_VERSION_MIGRATION[SUB_EX_AGE][1] = function (prev) {
  const data = copyObject(DEFAULT_AGENCIES_LIST())
  data.forEach((agency, index) => {
    agency.data = prev[index]?.data ?? agency.data
  })
  return { data, v: 2 }
}

SUB_VERSION_MIGRATION[SUB_EX_AGE][2] = function (prev) {
  prev.data.forEach(item => {
    if (item.name === 'CADTH') item.name = 'CDA'
  })
  return { data: prev.data, v: 3 }
}

SUB_VERSION_MIGRATION[SUB_EX_AGE][3] = function (prev) {
  if (prev?.indications?.length) {
    return normalizeAgenciesExpertise(prev)
  }
  if (prev?.data) {
    return normalizeAgenciesExpertise(prev)
  }
  return EX_AGENCIES_DEFAULT()
}
